<template>
  <v-btn
    variant="plain"
    density="comfortable"
    :ripple="false"
    :class="$style.closeWindowIconBtn"
    data-testid="closeWindowIconBtn"
    icon="mdi-close"
  >
  </v-btn>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.closeWindowIconBtn {
  opacity: 1;
  color: colors.$color-text-tertiary;

  :global {
    .v-btn__content {
      color: colors.$color-text-tertiary;
    }
  }

  &:hover {
    :global {
      .v-btn__content {
        color: colors.$color-brand-400;
      }
    }
  }

  &:active {
    :global {
      .v-btn__content {
        color: colors.$color-brand-300;
      }
    }
  }
}
</style>
